import { Pipe, PipeTransform } from '@angular/core';
import { Question } from 'src/app/features/medical-record/model/question.model';

@Pipe({
  name: 'isTextEmpty'
})
export class IsTextEmptyPipe implements PipeTransform {

  transform(value?: string, ...args: unknown[]): boolean {
    return ((value ?? '').trim()! == '');
  }
}

@Pipe({
  name: 'isQuestionEmpty'
})
export class IsQuestionEmptyPipe implements PipeTransform {

  transform(question?: Question | string, ...args: unknown[]): boolean {
    if (!question) {
      return true
    }
    else {
      if (typeof question === 'string') {
        if(question.trim() !== ''){
          return false;
        }
        return true;
      }
      else if (question.answer.length > 0){
        if (question.answer[0] === null || question.answer[0] === undefined) {
          return true
        }
        if (question.answer[0].trim() === '') {
          return true
        }
        if (!question.answer[0]) {
          return true
        }
      }
    }
    return false
  }
}
